import { ApolloLink } from '@apollo/client';
import { NextLink, Operation } from '@apollo/client/link/core/types';
import isMutation from './isMutation';
import { OperationsRepository } from './OperationsRepository';

export default class DurableMutationsLink extends ApolloLink {
  constructor(repository: OperationsRepository) {
    let started = false;
    // Track operations currently being executed to prevent duplicate replay
    const inFlightOperations = new Set<string>();
    
    super((operation: Operation, forward: NextLink) => {
      if (isMutation(operation)) {
        if (!started) {
          started = true;
          repository.list().then(operations => {
            operations.forEach(o => {
              // Skip operations that are currently in-flight
              if (!inFlightOperations.has(o.key as string)) {
                // Forward the operation and immediately remove from storage
                // Don't use forEach() as it creates a second subscription!
                forward(o);
                repository.remove(o.key);
              }
            });
          });
        }

        // Generate key and mark as in-flight BEFORE adding to storage
        const key = repository.add(operation);
        
        // Mark as in-flight immediately
        key.then(k => {
          const keyStr = String(k);
          inFlightOperations.add(keyStr);
        });
        
        const result = forward(operation);

        // Remove from storage immediately after forwarding
        // If the mutation fails, it won't be replayed (acceptable trade-off)
        key.then(k => {
          const keyStr = String(k);
          inFlightOperations.delete(keyStr);
          repository.remove(k);
        });

        return result;
      }

      return forward(operation);
    });
  }
}
